"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmationModel = exports.ConfirmationEntry = exports.ConfObject = void 0;
const tslib_1 = require("tslib");
require("babel-polyfill");
const Instance_1 = require("./Instance");
class ConfObject extends kendo.data.ObservableObject {
    // Methods
    constructor() {
        super();
        // Properties
        this.AvailableOptions = [];
        this.ChosenOption = undefined;
        this.SignState = ConfObject.SignState.NotSigned;
        this.SignAsDeputy = false;
        this.OnlyAcceptAndReject = false;
        this.Subject = "";
        this.Instance = undefined;
    }
    static fromJSON(confObjectJSON) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let confObjectReturn = new ConfObject();
            if (confObjectJSON["AvailableOptions"])
                confObjectReturn.AvailableOptions = ConfObject.Option.fromJSONArray(confObjectJSON["AvailableOptions"]);
            if (confObjectJSON["ChosenOption"])
                confObjectReturn.ChosenOption = ConfObject.Option.fromJSON(confObjectJSON["ChosenOption"]);
            if (confObjectJSON["SignState"])
                confObjectReturn.SignState = confObjectJSON["SignState"];
            if (confObjectJSON["SignAsDeputy"])
                confObjectReturn.SignAsDeputy = confObjectJSON["SignAsDeputy"];
            if (confObjectJSON["OnlyAcceptAndReject"])
                confObjectReturn.OnlyAcceptAndReject = confObjectJSON["OnlyAcceptAndReject"];
            if (confObjectJSON["Subject"])
                confObjectReturn.SignState = confObjectJSON["Subject"];
            if (confObjectJSON["Instance"])
                confObjectReturn.Instance = yield Instance_1.Instance.fromJSON(confObjectJSON["Instance"]);
            return confObjectReturn;
        });
    }
    static fromJSONArray(confObjectsJSON) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let confObjectsReturn = [];
            for (let confObjectJSON of confObjectsJSON) {
                confObjectsReturn.push(yield ConfObject.fromJSON(confObjectJSON));
            }
            return confObjectsReturn;
        });
    }
}
exports.ConfObject = ConfObject;
(function (ConfObject) {
    class Option extends kendo.data.ObservableObject {
        // Methods
        constructor() {
            super();
            // Properties
            this.Id = "";
            this.Name = "";
            this.IconId = "";
            this.IsSignOption = false;
            this.IsRejectOption = false;
        }
        static fromJSON(optionJSON) {
            let optionReturn = new Option();
            if (optionJSON["Id"])
                optionReturn.Id = optionJSON["Id"];
            if (optionJSON["Name"])
                optionReturn.Name = optionJSON["Name"];
            if (optionJSON["IconId"])
                optionReturn.IconId = optionJSON["IconId"];
            if (optionJSON["IsSignOption"])
                optionReturn.IsSignOption = optionJSON["IsSignOption"];
            if (optionJSON["IsRejectOption"])
                optionReturn.IsRejectOption = optionJSON["IsRejectOption"];
            return optionReturn;
        }
        static fromJSONArray(optionsJSON) {
            let optionsReturn = [];
            for (let optionJSON of optionsJSON) {
                optionsReturn.push(Option.fromJSON(optionJSON));
            }
            return optionsReturn;
        }
    }
    ConfObject.Option = Option;
    let SignState;
    (function (SignState) {
        SignState[SignState["NotSigned"] = 0] = "NotSigned";
        SignState[SignState["SignedProSe"] = 1] = "SignedProSe";
        SignState[SignState["SignedAsDeputy"] = 2] = "SignedAsDeputy";
        SignState[SignState["RejectedProSe"] = 3] = "RejectedProSe";
        SignState[SignState["RejectedAsDeputy"] = 4] = "RejectedAsDeputy";
        SignState[SignState["Invalid"] = 5] = "Invalid";
        SignState[SignState["Other"] = 6] = "Other";
    })(SignState = ConfObject.SignState || (ConfObject.SignState = {}));
})(ConfObject = exports.ConfObject || (exports.ConfObject = {}));
class ConfirmationEntry extends kendo.data.ObservableObject {
    // Methods
    constructor() {
        super();
        // Properties
        this.DocumentToConfirm = undefined;
        this.HasContent = false;
        this.Attachments = [];
        this.ConfirmationObjects = [];
    }
    static fromJSON(entryJSON) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let entryReturn = new ConfirmationEntry();
            if (entryJSON["DocumentToConfirm"])
                entryReturn.DocumentToConfirm = yield Instance_1.Instance.fromJSON(entryJSON["DocumentToConfirm"]);
            if (entryJSON["HasContent"])
                entryReturn.HasContent = entryJSON["HasContent"];
            if (entryJSON["Attachments"])
                entryReturn.Attachments = yield Instance_1.Instance.fromJSONArray(entryJSON["Attachments"]);
            if (entryJSON["ConfirmationObjects"])
                entryReturn.ConfirmationObjects = yield ConfObject.fromJSONArray(entryJSON["ConfirmationObjects"]);
            return entryReturn;
        });
    }
    static fromJSONArray(entriesJSON) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let entriesReturn = [];
            for (let entryJSON of entriesJSON) {
                entriesReturn.push(yield ConfirmationEntry.fromJSON(entryJSON));
            }
            return entriesReturn;
        });
    }
}
exports.ConfirmationEntry = ConfirmationEntry;
class ConfirmationModel extends kendo.data.ObservableObject {
    // Methods
    constructor() {
        super();
        // Properties
        this.total = 0;
        this.data = [];
        this.moreRowsAvailable = false;
    }
    static fromJSON(json) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let confModelReturn = new ConfirmationModel();
            if (json["total"])
                confModelReturn.total = json["total"];
            if (json["data"])
                confModelReturn.data = yield ConfirmationEntry.fromJSONArray(json["data"]);
            if (json["moreRowsAvailable"])
                confModelReturn.moreRowsAvailable = json["moreRowsAvailable"];
            return confModelReturn;
        });
    }
}
exports.ConfirmationModel = ConfirmationModel;
